import $ from 'jquery';

$('.ui-switch__label').click(function () {
    const $component = $(this).parents('.ui-switch');
    $component.find('input').prop("checked", +$(this).attr('data-value') === 1).trigger('change');
});

$('.ui-switch__value').change(function () {
    $('.ui-switch__label').removeClass('ui-switch__label--active');

    if ($(this).is(':checked')) {
        $('.ui-switch__label').last().addClass('ui-switch__label--active');
    } else {
        $('.ui-switch__label').first().addClass('ui-switch__label--active');
    }
})
